import styled from 'styled-components';

export const HeaderText = styled.h2`
    color: ${({ theme: { colors } }) => colors.black};
`;

export const SubHeaderText = styled.h3`
    color: ${({ theme: { colors } }) => colors.black};
`;
